import type { PageContext } from 'vike/types'
import { episodes } from './episodes/episodes'

export function title(pageContext: PageContext | {
  routeParams: {
    id: string
  }
}): string {
  const id = pageContext?.routeParams?.id ?? ''
  if (id === '') {
    return 'Playalong: Gamifying Creator Content - Reactvts'
  }
  if (episodes[id] === undefined) {
    return 'Playalong: Gamifying Creator Content - Reactvts'
  }
  const title = episodes[id].title.replace(/&quot;/g, '').replace(/["']/g, '')
  const creator = episodes[id].series.creator.name.replace(/&quot;/g, '').replace(/["']/g, '')
  return `Playalong to ${title} by ${creator} - Reactvts`
}
